module.exports = __webpack_public_path__ + "img/Freshdesk.ba4e9403.png";